var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 24C47.5 36.978 36.978 47.5 24 47.5C11.022 47.5 0.5 36.978 0.5 24C0.5 11.022 11.022 0.5 24 0.5C36.978 0.5 47.5 11.022 47.5 24Z",
    fill: "white",
    stroke: "#E2E6EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9995 24.2955C36.9995 23.3733 36.9146 22.4879 36.7584 21.6367H24.2656V26.6653H31.4049C31.0975 28.2904 30.1627 29.6669 28.7581 30.5891V33.8505H33.0457C35.5537 31.5872 37.0008 28.2549 37.0008 24.2955H36.9995Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2643 36.9986C27.8458 36.9986 30.8487 35.8339 33.0431 33.8487L28.7556 30.5873C27.5671 31.3675 26.0488 31.828 24.2631 31.828C20.8078 31.828 17.8836 29.5415 16.8402 26.4688H12.4102V29.8366C14.5933 34.085 19.0783 36.9986 24.2643 36.9986Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8421 26.4684C16.5772 25.6883 16.426 24.8555 16.426 23.9982C16.426 23.1409 16.5772 22.3081 16.8421 21.528V18.1602H12.4109C11.5124 19.9151 11 21.9003 11 23.9982C11 26.0961 11.5124 28.0813 12.4109 29.8363L16.8421 26.4684Z",
    fill: "#FBBC05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2643 16.1706C26.2113 16.1706 27.9608 16.827 29.3354 18.1142L33.1406 14.385C30.8425 12.2884 27.8396 11 24.2643 11C19.0783 11 14.5933 13.9135 12.4102 18.1619L16.8414 21.5298C17.8849 18.4571 20.809 16.1706 24.2643 16.1706Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnGoogle);
export default __webpack_public_path__ + "static/media/btn_google.f2f4e9c88bd65d4276c38edf8eb85663.svg";
export { ForwardRef as ReactComponent };